import EventHandlers from "@/services/handlers";

interface IEventHandler {
    copy2ClipboardWarningChanged?: () => void;
}

class WarningService {
    private readonly handlers = new EventHandlers<IEventHandler>();

    public copy2ClipboardTrigger() {
        this.handlers.publish((x) => x.copy2ClipboardWarningChanged?.());
    }

    public subscribe(handler: IEventHandler) {
        return this.handlers.register(handler);
    }
}

const warning = new WarningService();
export default warning;
